<template>
    <!-- 外层容器：设置全局背景色 -->
    <div class="protocol-page-wrapper">
        <!-- 主体容器：保持原有宽度 -->
        <div class="protocol-container">
            <!-- <el-button type="text" @click="goLogin" style="float: left;color: #999;" icon="el-icon-arrow-left">
                返回登录页
            </el-button> -->
            <div class="protocol-header">
                <h1>智步云上模型网支付协议</h1>
            </div>
            <div class="protocol-content">
                <!-- 这里放置服务协议的具体内容 -->
                <div class="protocol-section">
                    <p>欢迎您购买智步云上模型网上交易平台付费内容！请您在购买之前仔细阅读并充分理解本《智步云上模型网上交易平台支付协议》。如果您未满18周岁，请在法定监护人的陪同下阅读本协议。为了保障您的权益，请在进行下一步操作前，详细阅读本协议的所有内容，特别是免除或限制责任的相应条款。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>一、协议的范围</h2>
                    <h4>1.协议适用主体范围
                    </h4>
                    <p>本协议是您与智步云上模型网上交易平台经营者（北京市智步云上科技有限公司）之间关于您使用本服务所订立的协议。
                    </p>
                    <h4>2.协议的内容
                    </h4>
                    <p>本协议视为《网站服务条款》的补充协议，是其不可分割的组成部分，与其构成统一整体。本协议与上述内容存在冲突的，以本协议为准。</p>
                    <p>本协议内容包括本协议正文、智步云上模型网上交易平台已经发布和将来可能发布的相关的各类规则。所有规则为本协议不可分割的组成部分，与本协议具有同等法律效力。一旦相关内容发生变动，智步云上模型网上交易平台将在相关页面提示您。如果您不同意对本协议内容所做的修改，则应立即停止使用本服务；如果您继续使用本服务的，则视为您同意对本协议内容所做的修改。</p>
                </div>
                <div class="protocol-section">
                    <h2>二、购买方式</h2>
                    <p>您应该通过智步云上模型网上交易平台指定的包括但不限于支付宝、微信支付等现有或未来新增的方式依约支付一定费用后购买付费内容。如您通过任何非智步云上模型网上交易平台官方途径进行交易，智步云上模型网上交易平台有权根据实际情况终止向您提供或继续提供已购买的部分或全部付费内容，且无须承担任何责任。购买之后，适用“一人一账号”原则，各个账号之间的使用权限不得更改或转移、互赠、售卖、租借、分享给任何人，各账号使用权限有且仅有开通该账号的用户享有，否则，智步云上模型网上交易平台有权对该账号进行封号、中止或终止对您的服务。请您在登录/支付/参加活动时注意区分，避免造成损失。若造成损失的，由您自行承担。</p>
                </div>
                <div class="protocol-section">
                    <h2>三、退款</h2>
                    <p>除因智步云上模型网上交易平台提供的付费内容无法观看或智步云上模型网上交易平台无法提供或继续提供外，您已购买的付费内容不支持退换且无法转移使用。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>四、价格说明</h2>
                    <p>页面中的划线价格指付费内容的官方指导价格，并非原价。未划线价格指付费内容的实时价格。在使用优惠券或特定优惠活动和时段等情形下的具体成交价格以订单结算页价格为准。优惠券的使用规则请以优惠券详情页说明为准。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>五、知识产权</h2>
                    <p>您的购买行为不被视为付费内容的知识产权权属转移，您已经购买的付费内容仅能由您本人在智步云上模型网上交易平台平台观看学习使用。您不得采取出售、转让、盗用、租赁账户等方式分享或获取付费内容，亦不得以录制屏幕或其他技术手段下载、传播付费内容。如您存在前述违规行为，智步云上模型网上交易平台有权根据具体情形采取包括但不限于终止部分/全部付费视频的观看权、封禁相关账号等措施。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>六、免责声明</h2>
                    <p>因不可抗力以及您的个人原因导致付费内容无法正常观看的情况下，智步云上模型网上交易平台无须承担任何责任。
                    </p>
                    <p>您理解并同意：智步云上模型网上交易平台向您提供的服务，包含智步云上模型网上交易平台经合法权利人授权而向您提供的相关服务，因此，由于该权利人对智步云上模型网上交易平台授权时间、范围、限制等的约束，所以智步云上模型网上交易平台会对开通相关服务用户所在的地区以及用户具体使用服务的时间、地域范围等做出一定限制，可能导致您在一定的地区或时间等情况下无法获得相关服务。这种情况下，智步云上模型网上交易平台不承担任何责任。</p>
                </div>
                <div class="protocol-section">
                    <h2>七、联系</h2>
                    <p>若您在购买付费内容时有任何问题或疑问，您可以随时咨询在线客服。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>八、其他</h2>
                    <h4>1.协议的生效</h4>
                    <p>您使用本服务即视为您已阅读并同意受本协议的约束。
                    </p>
                    <h4>2.协议签订地</h4>
                    <p>本协议签订地为中华人民共和国北京市昌平区。</p>
                    <h4>3.适用法律</h4>
                    <p>本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
                    <h4>4.条款标题</h4>
                    <p>本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
                    <h4>5.条款效力</h4>
                    <p>本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
                </div>
                <!-- 更多协议内容... -->
            </div>
        </div>
        <!-- 底部版权：固定在页面底部 -->
        <div class="protocol-footer-wrapper">
            <!-- <Bottom></Bottom> -->
        </div>
    </div>
</template>

<script>
import Bottom from '../../components/Footer.vue';
export default {
    name: 'PrivacyPolicy',
    components: {
        Bottom
    },
    methods: {
        goLogin() {
            this.$router.push('/Login');
        },
    }
}
</script>

<style lang="less" scoped>
// 页面外层容器：设置全局背景色，确保占满整个视口
.protocol-page-wrapper {
    width: 100%;
    min-height: 100vh;
    background-color: #232323; // 两侧背景色
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

// 主体容器：保持原有宽度，内容居中
.protocol-container {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box; // 确保padding不影响宽度
    flex: 1; // 占满除底部外的剩余空间
}

.protocol-header {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #444; // 适配深色背景的分隔线

    h1 {
        font-size: 24px;
        color: #E3E3E3;
        font-weight: 600;
    }
}

.protocol-content {
    font-size: 16px;
    line-height: 1.8;
    color: #ACACAC;

    .protocol-section {
        margin-bottom: 25px;

        h2 {
            font-size: 18px;
            color: gainsboro;
            margin-bottom: 10px;
            font-weight: bold;
        }

        p {
            margin-bottom: 10px;
            text-indent: 2em;
        }
    }
}
</style>